module.exports = __webpack_public_path__ + "static/media/fz_schdview_pt_PT.af02adef.png";